var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',_vm._b({attrs:{"options":_vm.internalOptions,"value":_vm.value,"clear-on-select":false,"loading":_vm.isLoading},on:{"input":_vm.onInput,"search-change":_vm.onSearchChange}},'treeselect',_vm.propsToPass,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }